export default {
  sm: `
  데이터센터 각은 환경, 사람 그리고 성공적인 
  비즈니스까지 고려한 친환경 데이터센터의 기준이 
  되고자 합니다.
  `,
  md: `
  데이터센터 각은 환경, 사람 그리고 성공적인 비즈니스까지 고려한 친환경 데이터센터의 기준이 되고자 합니다.
  `
};
